<div class="container-geral bg-white h-full relative">
  <div class="flex items-center justify-between mb-6">
    <div class="flex items-center gap-2">
      <h1 class="text-blue-500 text-heading-lg font-bold m-0">
        Espaços escolares: reforma e adequação
      </h1>
      <div class="relative" (mouseenter)="abrirTooltips()" (mouseleave)="fecharTooltips()">
        <mat-icon class="text-neutral-400 cursor-pointer text-lg">info</mat-icon>
        <span
          #infoTooltip="matTooltip"
          matTooltip="Nesta etapa você pode adicionar manualmente a quantidade de novos prédios a serem construídos, substituindo o cálculo automático baseado na demanda."
          matTooltipPosition="right"
          class="absolute"
        ></span>
      </div>
    </div>

    <button
      mat-raised-button color="primary"
      *ngIf="!edicaoBloqueada"
      (click)="downloadCsvNovasSalasEdicao()">
      <mat-icon>download</mat-icon>
      <div class="novas-salas-loading-content-image flex flex-col items-center">
        <img *ngIf="isDownloadCsvNovasSalasEdicaoCarregando else textoNormal"  src="assets/ilustrations/loading-circle.png" alt="loading" class="mb-2" />
        <ng-template #textoNormal>
          <span>Baixar CSV</span>
        </ng-template>
      </div>
    </button>
  </div>

  <div class="texto-alerta">
    <mat-icon class="text-red-500 text-sm" style="width: 16px; height: 16px; font-size: 16px;">error</mat-icon>
    <span>Consulte o relatório de demandas para a construção de novas salas por escola.</span>
  </div>

  <!-- Tabela de Demanda por Novas Salas -->
  <div class="table-content rounded-sm sm-shadow mb-6" *ngIf="memoriaDeCalculo">
    <app-tabela [cabecalhoCustomizado]="true" ngSkipHydration>
      <ng-container cabecalho>
        <tr>
          <th class="top-left-header text-body-lg align-start" style="width: 30%">Etapa/modalidade</th>
          <th class="top-header text-body-lg align-end" style="width: 20%; text-align: right;">Área de localidade</th>
          <th class="top-header text-body-lg align-start" style="width: 20%">Número de salas de aula existentes<sup>(1)</sup></th>
          <th class="top-header text-body-lg align-start" style="width: 15%">Salas de aula necessárias<sup>(2)</sup></th>
          <th class="top-right-header text-body-lg align-start" style="width: 15%">Demanda por novas salas de aula<sup>(3)</sup></th>
        </tr>
      </ng-container>
      <ng-container corpo>
        <!-- Educação Infantil -->
        <tr class="cells-row">
          <td [attr.rowspan]="2" class="left-cell text-body-lg align-start align-middle border-r">Educação Infantil</td>
          <td class="text-body-lg align-end align-middle" style="text-align: right;">Urbana</td>
          <!-- Salas Existentes Total Mesclado -->
          <td [attr.rowspan]="4" class="text-body-lg align-start align-middle border-r border-l">
            {{ memoriaDeCalculo ? memoriaDeCalculo.resultadoParte9_2ResultadoSalasExistentes.resultadoNumSalasExistentesTotal.toLocaleString('pt-BR') : 0 }}
          </td>
          <td class="text-body-lg align-start align-middle">
            {{ memoriaDeCalculo ? memoriaDeCalculo.resultadoParte9_3ResultadoSalasNecessarias.resultadoNumSalasNecessariasEdInfantilUrbana.toLocaleString('pt-BR') : 0 }}
          </td>
          <td class="right-cell text-body-lg align-start align-middle">
            {{ memoriaDeCalculo ? memoriaDeCalculo.resultadoParte9_4DemandaPorNovasSalas.resultadoDemandaSalasEdInfantilUrbana.toLocaleString('pt-BR') : 0 }}
          </td>
        </tr>
        <tr class="cells-row">
          <td class="text-body-lg align-end align-middle" style="text-align: right;">Rural</td>
          <td class="text-body-lg align-start align-middle">
            {{ memoriaDeCalculo ? memoriaDeCalculo.resultadoParte9_3ResultadoSalasNecessarias.resultadoNumSalasNecessariasEdInfantilRural.toLocaleString('pt-BR') : 0 }}
          </td>
          <td class="right-cell text-body-lg align-start align-middle">
            {{ memoriaDeCalculo ? memoriaDeCalculo.resultadoParte9_4DemandaPorNovasSalas.resultadoDemandaSalasEdInfantilRural.toLocaleString('pt-BR') : 0 }}
          </td>
        </tr>

        <!-- Ensino Fundamental / Médio / EJA -->
        <tr class="cells-row">
          <td [attr.rowspan]="2" class="left-cell text-body-lg align-start align-middle border-r">
            Ensino Fundamental anos iniciais<br>e finais<br>Ensino Médio<br>EJA
          </td>
          <td class="text-body-lg align-end align-middle" style="text-align: right;">Urbana</td>
          <td class="text-body-lg align-start align-middle">
            {{ memoriaDeCalculo ? memoriaDeCalculo.resultadoParte9_3ResultadoSalasNecessarias.resultadoNumSalasNecessariasEnsFunEnsMedioEjaUrbana.toLocaleString('pt-BR') : 0 }}
          </td>
          <td class="right-cell text-body-lg align-start align-middle">
            {{ memoriaDeCalculo ? memoriaDeCalculo.resultadoParte9_4DemandaPorNovasSalas.resultadoDemandaSalasEnsFunEnsMedioEjaUrbana.toLocaleString('pt-BR') : 0 }}
          </td>
        </tr>
        <tr class="cells-row">
          <td class="text-body-lg align-end align-middle" style="text-align: right;">Rural</td>
          <td class="text-body-lg align-start align-middle">
            {{ memoriaDeCalculo ? memoriaDeCalculo.resultadoParte9_3ResultadoSalasNecessarias.resultadoNumSalasNecessariasEnsFunEnsMedioEjaRural.toLocaleString('pt-BR') : 0 }}
          </td>
          <td class="right-cell text-body-lg align-start align-middle">
            {{ memoriaDeCalculo ? memoriaDeCalculo.resultadoParte9_4DemandaPorNovasSalas.resultadoDemandaSalasEnsFunEnsMedioEjaRural.toLocaleString('pt-BR') : 0 }}
          </td>
        </tr>
      </ng-container>
    </app-tabela>
    <app-rodape-fonte-nota [foteNota]="notasTabelaDemanda"></app-rodape-fonte-nota>
  </div>

  <!-- Tabela de Edição de Novos Prédios -->
  <div class="table-content rounded-sm sm-shadow">
    <app-tabela [cabecalhoCustomizado]="true" ngSkipHydration>
      <ng-container cabecalho>
        <tr>
          <th class="top-left-header text-body-lg align-start">Etapa/modalidade</th>
          <th class="top-header text-body-lg align-start">Tipo de construção</th>
          <th class="top-header text-body-lg align-start">Tamanho m²</th>
          <th class="top-header text-body-lg align-end" style="text-align: right;">Área localidade</th>
          <th class="top-header text-body-lg align-start">Quantidade de construção</th>
          <th class="top-header text-body-lg align-start">Valor da construção (R$)</th>
          <th class="top-right-header text-body-lg align-start">Despesa de capital (R$)</th>
        </tr>
      </ng-container>
      <ng-container corpo>
        <!-- Educação Infantil -->
        <ng-container *ngFor="let pqr of getPqrsEducacaoInfantil(); let pqrIndex = index">
          <tr class="cells-row">
            <!-- Etapa/modalidade - mesclada para todos os PQRs de EI -->
            <td
              *ngIf="pqrIndex === 0"
              [attr.rowspan]="getTotalLinhasPorEtapa('EI')"
              class="left-cell text-body-lg align-start align-middle border-r">
              Educação Infantil
            </td>

            <!-- Tipo de construção - mesclada para Urbana + Rural -->
            <td [attr.rowspan]="2" class="text-body-lg align-start align-middle border-r">
              {{ pqr.descricaoTipoConstrucao }}
            </td>

            <!-- Tamanho m² - mesclada para Urbana + Rural -->
            <td [attr.rowspan]="2" class="text-body-lg align-start align-middle border-r">
              {{ pqr.dimensao | number:'1.0-3' }}
            </td>

            <!-- Linha Urbana -->
            <td class="text-body-lg align-end align-middle border-l" style="text-align: right;">Urbana</td>
            <td class="text-body-lg align-start align-middle p-2">
              <input
                type="text"
                class="input-quantidade"
                [value]="getQuantidade(pqr, 'Urbana', true)"
                (input)="atualizarOverride(pqr, 'Urbana', true, $event)"
                [maskito]="maskInteiro"
                [disabled]="edicaoBloqueada"
              />
            </td>
            <td class="text-body-lg align-start">
              {{ calcularValorConstrucao(pqr) | currency:'BRL':'symbol':'1.2-2' }}
            </td>
            <td class="right-cell text-body-lg align-start">
              {{ calcularDespesa(pqr, 'Urbana', true) | currency:'BRL':'symbol':'1.0-0' }}
            </td>
          </tr>

          <!-- Linha Rural -->
          <tr class="cells-row">
            <td class="text-body-lg align-end align-middle border-l" style="text-align: right;">Rural</td>
            <td class="text-body-lg align-start align-middle p-2">
              <input
                type="text"
                class="input-quantidade"
                [value]="getQuantidade(pqr, 'Rural', true)"
                (input)="atualizarOverride(pqr, 'Rural', true, $event)"
                [maskito]="maskInteiro"
                [disabled]="edicaoBloqueada"
              />
            </td>
            <td class="text-body-lg align-start">
              {{ calcularValorConstrucao(pqr) | currency:'BRL':'symbol':'1.2-2' }}
            </td>
            <td class="right-cell text-body-lg align-start">
              {{ calcularDespesa(pqr, 'Rural', true) | currency:'BRL':'symbol':'1.0-0' }}
            </td>
          </tr>
        </ng-container>

        <!-- Ensino Fundamental / Médio / EJA -->
        <ng-container *ngFor="let pqr of getPqrsEnsinoFundamentalMedioEja(); let pqrIndex = index">
          <tr class="cells-row">
            <!-- Etapa/modalidade - mesclada para todos os PQRs de EF/EM/EJA -->
            <td
              *ngIf="pqrIndex === 0"
              [attr.rowspan]="getTotalLinhasPorEtapa('EF')"
              class="left-cell text-body-lg align-start align-middle border-r">
              Ensino Fundamental anos iniciais<br>e finais<br>Ensino Médio<br>EJA
            </td>

            <!-- Tipo de construção - mesclada para Urbana + Rural -->
            <td [attr.rowspan]="2" class="text-body-lg align-start align-middle border-r">
              {{ pqr.descricaoTipoConstrucao }}
            </td>

            <!-- Tamanho m² - mesclada para Urbana + Rural -->
            <td [attr.rowspan]="2" class="text-body-lg align-start align-middle border-r">
              {{ pqr.dimensao | number:'1.0-3' }}
            </td>

            <!-- Linha Urbana -->
            <td class="text-body-lg align-end align-middle border-l" style="text-align: right;">Urbana</td>
            <td class="text-body-lg align-start align-middle p-2">
              <input
                type="text"
                class="input-quantidade"
                [value]="getQuantidade(pqr, 'Urbana', false)"
                (input)="atualizarOverride(pqr, 'Urbana', false, $event)"
                [maskito]="maskInteiro"
                [disabled]="edicaoBloqueada"
              />
            </td>
            <td class="text-body-lg align-start">
              {{ calcularValorConstrucao(pqr) | currency:'BRL':'symbol':'1.2-2' }}
            </td>
            <td class="right-cell text-body-lg align-start">
              {{ calcularDespesa(pqr, 'Urbana', false) | currency:'BRL':'symbol':'1.0-0' }}
            </td>
          </tr>

          <!-- Linha Rural -->
          <tr class="cells-row">
            <td class="text-body-lg align-end align-middle border-l" style="text-align: right;">Rural</td>
            <td class="text-body-lg align-start align-middle p-2">
              <input
                type="text"
                class="input-quantidade"
                [value]="getQuantidade(pqr, 'Rural', false)"
                (input)="atualizarOverride(pqr, 'Rural', false, $event)"
                [maskito]="maskInteiro"
                [disabled]="edicaoBloqueada"
              />
            </td>
            <td class="text-body-lg align-start">
              {{ calcularValorConstrucao(pqr) | currency:'BRL':'symbol':'1.2-2' }}
            </td>
            <td class="right-cell text-body-lg align-start">
              {{ calcularDespesa(pqr, 'Rural', false) | currency:'BRL':'symbol':'1.0-0' }}
            </td>
          </tr>
        </ng-container>

        <!-- Linha de Total -->
        <tr class="cells-row" style="background-color: #F9FAFB; font-weight: 600;">
          <td colspan="6" class="text-body-lg align-end" style="text-align: right; padding-right: 16px;">Total</td>
          <td class="right-cell text-body-lg align-start" style="font-weight: 600;">
            {{ calcularTotalDespesa() | currency:'BRL':'symbol':'1.0-0' }}
          </td>
        </tr>
      </ng-container>
    </app-tabela>
    <app-rodape-fonte-nota [foteNota]="notasTabelaDemanda"></app-rodape-fonte-nota>
  </div>
</div>
